type StorefrontLocation = Pick<Location, "protocol" | "hostname">;

export interface StorefrontSeoLinks {
  baseUrl: string;
  sitemapUrl: string;
  robotsUrl: string;
}

function trimTrailingSlash(value: string) {
  return value.trim().replace(/\/+$/, "");
}

export function resolveStorefrontUrl(configuredUrl = "", currentLocation?: StorefrontLocation) {
  const normalized = trimTrailingSlash(configuredUrl);
  if (normalized) return normalized;

  const location =
    currentLocation ??
    (typeof window !== "undefined" ? window.location : undefined);

  if (!location) return "";

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    return `${location.protocol}//${location.hostname}:3001`;
  }

  return "";
}

export function buildStorefrontSeoLinks(configuredUrl = "", currentLocation?: StorefrontLocation) {
  const baseUrl = resolveStorefrontUrl(configuredUrl, currentLocation);
  if (!baseUrl) return null;

  return {
    baseUrl,
    sitemapUrl: `${baseUrl}/sitemap.xml`,
    robotsUrl: `${baseUrl}/robots.txt`,
  } satisfies StorefrontSeoLinks;
}
